import { React, useEffect, useState } from 'react';
import Gate from './gate/Gate';
import style from './hall.module.scss';
import NavigationUser from '../../components/common/navigationUser/NavigationUser'; 
import Navegation from '../common/navegationHome/Navegation';

const Hall = () => {
  const [supNav, setSupNav] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'supplier') {
      setSupNav(true);
    }
  }, []);

  const {
    floor
  } = style;

  return(
    <div>
      {supNav ? <Navegation /> : <NavigationUser/>}
      <div className={floor}>
        <Gate/>
      </div>
    </div>
  );
};

export default Hall;